import {Routes, Route, useNavigationType, useLocation} from "react-router-dom";
import React, {useEffect} from "react";
import * as Pages from "@adminPages";
import {AdminScreenId} from "@assets";

interface IRoute {
  path: AdminScreenId;
  element: JSX.Element;
}
const initRouteList: IRoute[] = [
  {path: AdminScreenId.HOME, element: <Pages.HomeInfoPage />},
  {path: AdminScreenId.ADV, element: <Pages.AdvPage />},
  {path: AdminScreenId.ABOUT, element: <Pages.AboutInfoPage />},
  {path: AdminScreenId.ORGANIC, element: <Pages.OrganicInfoPage />},
  {path: AdminScreenId.NOTICE, element: <Pages.NoticePage />},
  {path: AdminScreenId.NOTICE_DETAIL, element: <Pages.NoticeDetailPage />},
  {path: AdminScreenId.BOARD, element: <Pages.BoardPage />},
  {path: AdminScreenId.BOARD_DETAIL, element: <Pages.BoardDetailPage />},
  {path: AdminScreenId.MEMBER, element: <Pages.MemberPage />},
  {path: AdminScreenId.MEMBER_DETAIL, element: <Pages.MemberDetailPage />},
  {path: AdminScreenId.USER, element: <Pages.UserPage />},
  {path: AdminScreenId.POPUP, element: <Pages.PopupPage />},
  {path: AdminScreenId.POPUP_DETAIL, element: <Pages.PopupDetailPage />},
  {path: AdminScreenId.USER, element: <Pages.ErrorPage />},
];

export default function AdminRouteApp() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") window.scrollTo(0, 0);
  }, [action, pathname]);

  return (
    <Routes>
      <Route
        path="/"
        element={(initRouteList || [])[0]?.element || <Pages.ErrorPage />}
      />
      {initRouteList.map((_route, i) => (
        <Route
          key={i}
          path={`/${removePrefixIfStartsWith({
            text: _route.path,
            prefix: "/admin",
          })}`}
          element={_route.element}
        />
      ))}
      <Route path="*" element={<Pages.ErrorPage />} />
    </Routes>
  );
}

function removePrefixIfStartsWith({
  text,
  prefix,
}: {
  text: string;
  prefix: string;
}) {
  if (text.startsWith(prefix)) {
    return text.replace(prefix, "");
  }
  return text;
}
